import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  onClick,
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 shadow-sm hover:shadow-md';
  const variants = {
    primary: 'bg-brand-sage text-white hover:bg-brand-sage-dark',
    secondary: 'bg-brand-coral text-white hover:bg-[#c47a6d]'
  };
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href && href.startsWith('#') && href.length > 1) {
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    onClick?.(e);
  };
  return <motion.a href={href} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-217">
      {children}
    </motion.a>;
}